'use client';

import { TimeAgo } from '@/components/ui/TimeAgo/TimeAgo';
import { CommentWithUser } from './types';
import { Varified } from '@/components/icons/Varified';
import { OAuthLink } from '@/contexts/OAuthFlowContext';
import { creatorName } from '@/utils/helpers';

interface CommentHeaderProps {
  comment: CommentWithUser;
  toneUsername: string;
  isApiSelect?: boolean;
}

export function CommentHeader({ comment, toneUsername, isApiSelect = false }: CommentHeaderProps) {
  const isVarified = !!comment.is_verified;
  const displayName = creatorName(comment);
  return (
    <div className="flex flex-col sm:flex-row sm:pt-[4px] sm:items-center sm:gap-3">
      <div className="flex items-center gap-3">
        <OAuthLink
          href={isApiSelect ? `/api/v1/select/${comment.username}` : `/${comment.username}`}
          className="flex items-center gap-2"
        >
          <span className="text-base font-semibold">{displayName}</span>
        </OAuthLink>
        {isVarified && <Varified size={20} className="ml-0 mr-0" />}
        {comment.username === toneUsername && (
          <span className="text-zinc-400 text-xs font-bold">Creator</span>
        )}
      </div>
      <span className="text-zinc-400 text-xs">
        <TimeAgo date={comment.created_at!} live />
        {!comment.is_deleted && comment.updated_at !== comment.created_at && ' (edited)'}
        {comment.is_deleted && ` (${comment.is_mod_delete ? 'mod delete' : 'deleted'})`}
      </span>
    </div>
  );
}
